// Customer Segments mock data
export const customerSegmentsMockData = [
  {
    id: "segment-1",
    name: "High Value Customers",
    description: "Customers with lifetime value over $2,000",
    criteria: [
      { type: "LIFETIME_VALUE", value: ">2000" },
      { type: "PURCHASE_FREQUENCY", value: ">5" }
    ],
    customerCount: 5872,
    createdAt: "2024-01-15T08:30:15Z",
    updatedAt: "2024-02-10T14:22:45Z"
  },
  {
    id: "segment-2",
    name: "Recent Purchasers",
    description: "Customers who made a purchase in the last 30 days",
    criteria: [
      { type: "LAST_PURCHASE", value: "<30d" }
    ],
    customerCount: 12463,
    createdAt: "2024-01-05T10:15:30Z",
    updatedAt: "2024-02-20T09:18:05Z"
  },
  {
    id: "segment-3",
    name: "Sustainable Shoppers",
    description: "Customers who prefer eco-friendly and sustainable products",
    criteria: [
      { type: "PRODUCT_CATEGORY", value: "SUSTAINABLE" },
      { type: "PURCHASE_COUNT", value: ">3" }
    ],
    customerCount: 8754,
    createdAt: "2023-11-20T15:45:10Z",
    updatedAt: "2024-02-05T11:30:25Z"
  },
  {
    id: "segment-4",
    name: "New Homeowners",
    description: "Customers who recently purchased home furnishing packages",
    criteria: [
      { type: "PRODUCT_BUNDLE", value: "NEW_HOME" },
      { type: "REGISTRATION_DATE", value: "<180d" }
    ],
    customerCount: 3215,
    createdAt: "2023-12-10T09:20:15Z",
    updatedAt: "2024-01-28T16:40:35Z"
  },
  {
    id: "segment-5",
    name: "At-Risk Customers",
    description: "Customers who haven't made a purchase in over 6 months",
    criteria: [
      { type: "LAST_PURCHASE", value: ">180d" },
      { type: "PREVIOUS_PURCHASE_COUNT", value: ">3" }
    ],
    customerCount: 7621,
    createdAt: "2023-10-05T14:25:30Z",
    updatedAt: "2024-02-15T10:10:45Z"
  },
  {
    id: "segment-6",
    name: "Kitchen Remodelers",
    description: "Customers purchasing kitchen products and services",
    criteria: [
      { type: "PRODUCT_CATEGORY", value: "KITCHEN" },
      { type: "INTEREST", value: "REMODELING" }
    ],
    customerCount: 2418,
    createdAt: "2024-01-22T11:35:20Z",
    updatedAt: "2024-02-18T13:50:05Z"
  },
  {
    id: "segment-7",
    name: "Loyalty Program Members",
    description: "Active members of the IKEA Family loyalty program",
    criteria: [
      { type: "MEMBERSHIP_STATUS", value: "ACTIVE" },
      { type: "MEMBERSHIP_DURATION", value: ">90d" }
    ],
    customerCount: 25740,
    createdAt: "2023-09-15T08:10:30Z",
    updatedAt: "2024-02-12T09:15:40Z"
  },
  {
    id: "segment-8",
    name: "Office Furnishers",
    description: "Customers purchasing products for home office setup",
    criteria: [
      { type: "PRODUCT_CATEGORY", value: "OFFICE" },
      { type: "PURCHASE_COUNT", value: ">2" }
    ],
    customerCount: 4325,
    createdAt: "2023-11-08T13:40:25Z",
    updatedAt: "2024-01-30T15:25:10Z"
  },
  {
    id: "segment-9",
    name: "Circular Economy Participants",
    description: "Customers who have used recycling, resale, or repair services",
    criteria: [
      { type: "SERVICE_USED", value: "RECYCLING,RESALE,REPAIR" },
      { type: "SERVICE_COUNT", value: ">1" }
    ],
    customerCount: 6129,
    createdAt: "2023-12-20T10:50:15Z",
    updatedAt: "2024-02-14T11:45:30Z"
  },
  {
    id: "segment-10",
    name: "Online Shoppers",
    description: "Customers who primarily shop through the website or app",
    criteria: [
      { type: "PURCHASE_CHANNEL", value: "ONLINE" },
      { type: "ONLINE_PURCHASE_RATIO", value: ">0.8" }
    ],
    customerCount: 18472,
    createdAt: "2023-10-25T09:15:45Z",
    updatedAt: "2024-02-08T14:20:35Z"
  },
  {
    id: "segment-11",
    name: "Small Space Living",
    description: "Customers interested in products for small apartments",
    criteria: [
      { type: "INTEREST", value: "SMALL_SPACE" },
      { type: "PRODUCT_TAG", value: "COMPACT,MULTIFUNCTIONAL" }
    ],
    customerCount: 7836,
    createdAt: "2023-11-15T12:30:20Z",
    updatedAt: "2024-02-01T10:40:15Z"
  },
  {
    id: "segment-12",
    name: "Families with Children",
    description: "Households with children under 12 years old",
    criteria: [
      { type: "HOUSEHOLD_COMPOSITION", value: "HAS_CHILDREN" },
      { type: "PRODUCT_CATEGORY", value: "CHILDREN" }
    ],
    customerCount: 9154,
    createdAt: "2023-10-10T15:20:40Z",
    updatedAt: "2024-01-25T13:10:55Z"
  }
];